import {observeOn, tap} from 'rxjs/operators';
import {Component, OnInit, AfterViewInit, ViewChild, forwardRef, OnDestroy} from '@angular/core';
import {Client, EfnCase, User} from '../../../../../../services/api.client';
import {EfnCaseFormComponent} from '../form/EfnCaseFormComponent';
import {EfnCaseHelper} from '../EfnHelper';
import {Observable, asapScheduler} from 'rxjs';
import {AutoDisableParent} from '../../../../../../directives/AutoDisableDirective';
import {ClientService} from '../../../../../../services/ClientService';
import {EfnService} from '../../../../../../services/EfnService';
import {formatDate} from '../../../../../../utilities/date-util';

@Component({
    selector: 'efnCase',
    templateUrl: './EditEfnCaseComponent.html',
    styleUrls: ['./EditEfnCaseComponent.scss'],
    providers: [EfnCaseHelper, { provide: AutoDisableParent, useExisting: forwardRef(() => EditEfnCaseComponent) }],
    standalone: false
})

export class EditEfnCaseComponent implements OnInit, AfterViewInit {

  client: Client;
  client$: Observable<Client>;

  @ViewChild(EfnCaseFormComponent)
  efnCaseForm: EfnCaseFormComponent;

  efnCase: EfnCase;
  efnCase$: Observable<EfnCase>;

  user: User;
  user$: Observable<User>;

  constructor(public helper: EfnCaseHelper,
              private _clientService: ClientService,
              private _efnService: EfnService) {
    this.client$ = this._clientService.currentClient$;
    this.efnCase$ = this._efnService.selectedEfnCase$;
  }


  ngOnInit(): void {
    this.client$.subscribe(client => this.client = client);
    this.efnCase$.subscribe(efnCase => this.efnCase = efnCase);
  }

  setupChild(): void {
    if (!this.helper.canEdit()) {
      this.efnCaseForm.form.disable();
    }
    this.efnCaseForm.form.patchValue({ ...this.efnCase, status: this.efnCase.status.toString().toLowerCase() });
    this.efnCaseForm.deadline.setValue(formatDate(this.efnCase.deadline, 'MM/DD/YYYY'));

    if (this.efnCase.company) {
      this.efnCaseForm.companyName.setValue(this.efnCase.company.name);
      this.efnCaseForm.selectedCompany$.next(this.efnCase.company);
    }

    if (this.detectOneTimeCompany()) {
      this.efnCaseForm.usesOneTimeCompany.setValue(true);
    } else {
      this.efnCaseForm.usesOneTimeCompany.setValue(false);
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.efnCase$
          .modelExists().pipe(
          observeOn(asapScheduler))
          .subscribe(() => this.setupChild());

    });


  }

  detectOneTimeCompany(): boolean {
    return this.efnCaseForm.paymentTo.value ||
        this.efnCaseForm.payeeAddress.value ||
        this.efnCaseForm.payeeAddress2.value ||
        this.efnCaseForm.payeeCity.value ||
        this.efnCaseForm.payeeState.value ||
        this.efnCaseForm.payeeZip.value;
  }

  submit(): Observable<EfnCase | null> {
    return this.efnCaseForm
        .updateCase(this.efnCase)
        .pipe(tap((efnCase) => {
          this.efnCase = efnCase;
        }));
  }

  printCase(): void {
    window.print();
  }
}
